import * as angular from "angular";
import * as _ from "lodash";
import {States} from "../../shared/config/constant.module";
import template from './commodityBin.tpl.html';
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import CommodityBinServiceName, {CommodityBinService} from "../../services/batches/commodityBin.service";
import CommoditiesServiceName, {CommoditiesService} from "../../services/batches/commodities.service";
import { apsCommands } from "../../shared/dto/aps.commands";

let requires = [LoaderServiceName, CommodityBinServiceName, CommoditiesServiceName,
   NavigationServiceName, NotifyServiceName];

interface CommodityBinController {
  commodityBins: apsViewModels.CommodityBinMapping[];
  edit(instance: apsViewModels.CommodityBinMapping): void;
  save(): void;
  reset(): void;
}

class CommodityBinCtrl implements CommodityBinController {
  backupcommodityBins: apsViewModels.CommodityBinMapping[] = [];
  commodityBins: apsViewModels.CommodityBinMapping[] = [];
  plants: Plant[];
  selectedPlant: Plant;
  currentselectedCommodity: apsViewModels.CommodityItem;
  selectedTank: any;
  changes: boolean = false;
  commodities: apsViewModels.CommodityItem[] = [];

  private loaderService: LoaderService;
  private navigationService: NavigationService;
  private commoditiesService: CommoditiesService;
  private commodityBinService: CommodityBinService;
  private notifyService: NotifyService;
  private $q: angular.IQService;

  constructor(
    loaderService: LoaderService,
    commodityBinService: CommodityBinService,
    commoditiesService: CommoditiesService,
    navigationService: NavigationService,
    notifyService: NotifyService,
    $q: angular.IQService,
  ) {

    this.loaderService = loaderService;
    this.navigationService = navigationService;
    this.commodityBinService = commodityBinService;
    this.commoditiesService = commoditiesService;
    this.notifyService = notifyService;
    this.$q = $q;

    let promise = this.navigationService.getNavigation()
    .then(nav => {
      this.plants = nav.plants();


      if (nav.selectedPlant && _.includes(this.plants, nav.selectedPlant)) {
        this.selectedPlant = nav.selectedPlant;
      } else {
        this.selectedPlant = _.first(this.plants);
      }
      this.plantChanged();
      this.loadCommodities();
    });

    this.loaderService.loadingPromise(promise);
  }

  plantChanged(): void {
    this.selectedTank = _.first(this.selectedPlant.tanks);
    let promises = [];
    promises.push(this.loadMappings());
    promises.push(this.loadCommodities())
    this.loaderService.loadingPromise(this.$q.all(promises));
  }
  
  tankChanged(): void {
    this.loaderService.loadingPromise(this.loadMappings());
  }

  loadCommodities(): angular.IPromise<any> {
    return this.commoditiesService
      .get(this.selectedPlant.id)
      .then(commodities => {
        this.changes = false;

        this.commodities = commodities.sort((a, b) => {
                                  if(a.name < b.name) { return -1; }
                                  if(a.name > b.name) { return 1; }
                                  return 0;
                          });
      });
  }

  loadMappings(): angular.IPromise<any> {
    return this.commodityBinService
      .get(this.selectedPlant.id, this.selectedTank.id)
      .then(mappings => {
        this.backupcommodityBins = angular.copy(mappings);
        this.commodityBins = mappings;
      });
  }

  edit(instance: apsViewModels.CommodityBinMapping): void {
    instance.commodityId = undefined;
    instance.commodityName = undefined;
    this.changes=true;
  }

  changeCommodity(instance: apsViewModels.CommodityBinMapping): void {
    instance.commodityName = this.currentselectedCommodity.name  + ' (' +this.currentselectedCommodity.shortItem +')';
    instance.commodityId = this.currentselectedCommodity.id;
    this.changes=true;
    this.currentselectedCommodity = undefined;
  }

  save(): void {
    let command = <apsCommands.UpdateCommodityBinMapping>{
      mappings: this.commodityBins
    };
    this.loaderService.loadingPromise(
      this.commodityBinService.update(command)
        .then(result =>  {
          this.changes = false;
          this.notifyService.success("Updated mappings successfully"); 
          this.backupcommodityBins = angular.copy(this.commodityBins);
        })
        .catch(this.notifyService.handleApiErrors)
    );
  }
  reset(): void {
    this.commodityBins = angular.copy(this.backupcommodityBins);
    this.changes = false;
  }
}

export default angular.module('aps.controller.commodityBin', requires)
  .config(($stateProvider: angular.ui.IStateProvider) => {
    $stateProvider.state({
      name: States.COMMODITY_BIN,
      url: '/admin/commodityBin',
      controller: 'CommodityBinCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Commodity Bin Mapping',
        authorizePlantAdmin: true
      }
    });
  })
  .controller('CommodityBinCtrl', CommodityBinCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/commodityBin.controller.ts